export class AzureRestorePointData {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "restorePointId",
            "baseName": "restorePointId",
            "type": "string",
            "format": ""
        },
        {
            "name": "restorePointName",
            "baseName": "restorePointName",
            "type": "string",
            "format": ""
        },
        {
            "name": "restorePointType",
            "baseName": "restorePointType",
            "type": "AzureRestorePointDataRestorePointTypeEnum",
            "format": ""
        },
        {
            "name": "location",
            "baseName": "location",
            "type": "string",
            "format": ""
        },
        {
            "name": "createdAt",
            "baseName": "createdAt",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "diskIds",
            "baseName": "diskIds",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "disks",
            "baseName": "disks",
            "type": "Array<AzureRestorePointDisk>",
            "format": ""
        },
        {
            "name": "vaultName",
            "baseName": "vaultName",
            "type": "string",
            "format": ""
        },
        {
            "name": "vaultResourceGroup",
            "baseName": "vaultResourceGroup",
            "type": "string",
            "format": ""
        },
        {
            "name": "vaultType",
            "baseName": "vaultType",
            "type": "AzureVaultType",
            "format": ""
        },
        {
            "name": "fileShareName",
            "baseName": "fileShareName",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return AzureRestorePointData.attributeTypeMap;
    }
    constructor() {
    }
}
export var AzureRestorePointDataRestorePointTypeEnum;
(function (AzureRestorePointDataRestorePointTypeEnum) {
    AzureRestorePointDataRestorePointTypeEnum["Compute"] = "compute";
    AzureRestorePointDataRestorePointTypeEnum["RecoveryServices"] = "recovery_services";
})(AzureRestorePointDataRestorePointTypeEnum || (AzureRestorePointDataRestorePointTypeEnum = {}));
